import classlist from 'utils/classlist';
import './style.scss';

export enum LoadingItemThemeEnum {
    DARK = 'dark',
    LIGHT = 'light'
}
export interface LoadingItemProps {
    content: React.ReactNode;
    theme?: LoadingItemThemeEnum;
}

const LoadingItem: React.FC<LoadingItemProps> = props => {
    const { content, theme = LoadingItemThemeEnum.DARK } = props;

    return (
        <div className={classlist('countdown-loading-item-root', theme)}>
            <div className="circle" />
            <span className="countdown">{content}</span>
        </div>
    );
};

export default LoadingItem;
